/**
 * Copyright (c) Trimble Inc. All rights reserved.
 */

import type { FeatureHubRepository } from 'featurehub-javascript-client-sdk';
import type { LocalFhClient } from './featureFlags';
import { mockFhClient } from './featureFlags';

/**
 * Singleton to manage FeatureHub client globally
 * This allows accessing the FeatureHub client from anywhere in the application
 * without prop drilling
 */
class FeatureHubClientManager {
  private client: FeatureHubRepository | LocalFhClient = mockFhClient;

  /**
   * Set the FeatureHub client instance
   * Should be called after user authentication when FeatureHub is initialized
   */
  setClient(client: FeatureHubRepository | LocalFhClient): void {
    this.client = client;
  }

  /**
   * Get the current FeatureHub client instance
   * Returns mockFhClient if not yet initialized
   */
  getClient(): FeatureHubRepository | LocalFhClient {
    return this.client;
  }

  /**
   * Check if a real FeatureHub client has been set
   * (as opposed to the mock client)
   */
  isInitialized(): boolean {
    return this.client !== mockFhClient;
  }

  /**
   * Reset to mock client (useful for testing or logout)
   */
  reset(): void {
    this.client = mockFhClient;
  }
}

// Export singleton instance
export const featureHubClientManager = new FeatureHubClientManager();
